var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2CF79D14-7A68-4E1A-A4A4-BA714DD36163") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MVP_Mobile/1",
    transform: "translate(-328.000000, -65.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base/Icons/UI/user-circle",
    transform: "translate(328.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C18.617,0 24,5.383 24,12 C24,15.674 22.345,19.094 19.457,21.391 L19.442,21.407 C19.399,21.45 19.355,21.476 19.33,21.491 C17.211,23.132 14.677,24 12,24 C9.323,24 6.789,23.132 4.668,21.49 C4.654,21.482 4.62933333,21.4677778 4.60140741,21.4461481 L4.542,21.391 L4.542,21.391 C1.655,19.094 0,15.674 0,12 C0,5.383 5.383,0 12,0 Z M12.001,18.7559979 C9.901,18.755 7.889,19.479 6.284,20.801 C7.99,21.914 9.956,22.5 12,22.5 C14.045,22.5 16.011,21.914 17.717,20.801 C16.113,19.479 14.101,18.7559979 12.001,18.7559979 Z M12,1.5 C6.21,1.5 1.5,6.21 1.5,12 C1.5,15.023 2.794,17.875 5.062,19.874 C6.977,18.184 9.428,17.257 12,17.257 C14.573,17.257 17.023,18.184 18.938,19.873 C21.206,17.873 22.5,15.022 22.5,11.999 C22.5,6.21 17.79,1.5 12,1.5 Z M12,3.75 C15.308,3.75 18,6.442 18,9.75 C18,13.058 15.308,15.75 12,15.75 C8.692,15.75 6,13.058 6,9.75 C6,6.442 8.692,3.75 12,3.75 Z M12,5.25 C9.519,5.25 7.5,7.269 7.5,9.75 C7.5,12.231 9.519,14.25 12,14.25 C14.481,14.25 16.5,12.231 16.5,9.75 C16.5,7.269 14.481,5.25 12,5.25 Z",
    id: "-Icon-Color"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.7e02fb3b6c7dde8069969a5723b22d57.svg";
export { ForwardRef as ReactComponent };